import { render, staticRenderFns } from "./IncomeTaxPolicyDetailsView.vue?vue&type=template&id=51eb2114&"
import script from "./IncomeTaxPolicyDetailsView.vue?vue&type=script&lang=js&"
export * from "./IncomeTaxPolicyDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./IncomeTaxPolicyDetailsView.vue?vue&type=style&index=0&id=51eb2114&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports